import React, { useContext, useEffect, useState, useMemo } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Avatar,
  Chip,
} from "@mui/material";
import {
  collection,
  onSnapshot,
  query,
  orderBy,
  addDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import { LanguageContext } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext"; // <-- import ajouté
import { statusColors } from "../constants/statusColors";

export default function TicketActivityHistoryMobile({
  ticket,
  role,
  selectedProject,
}) {
  const { translate } = useContext(LanguageContext);
  const { currentUser } = useAuth(); // <-- hook ajouté
  const [activities, setActivities] = useState([]);
  const [newComment, setNewComment] = useState("");

  // Subscription Firestore
  useEffect(() => {
    if (!ticket) return;
    const actCol = collection(
      db,
      "projects",
      selectedProject,
      "tickets",
      ticket.id,
      "activity"
    );
    const q = query(actCol, orderBy("timestamp", "desc"));
    return onSnapshot(q, (snap) => {
      setActivities(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
  }, [ticket, selectedProject]);

  // Filtre suivant rôle
  const visible = useMemo(() => {
    if (role === "Admin") return activities;
    return activities.filter(
      (a) =>
        a.action.startsWith("Statut") ||
        /Ticket créé|Ticket Created/.test(a.action) ||
        a.action.endsWith("Comment")
    );
  }, [activities, role]);

  const postComment = async (who) => {
    if (!newComment.trim()) return;
    await addDoc(
      collection(
        db,
        "projects",
        selectedProject,
        "tickets",
        ticket.id,
        "activity"
      ),
      {
        comment: newComment,
        performedBy: who,
        action: who === "Admin" ? "Admin Comment" : "User Comment",
        timestamp: new Date(),
      }
    );
    setNewComment("");
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2">{translate("TicketActivity")}</Typography>
      <Box
        sx={{
          maxHeight: "30vh",
          overflowY: "auto",
          mt: 1,
        }}
      >
        {visible.length ? (
          visible.map((a) => {
            let icon = "ℹ️";
            if (a.action.startsWith("Statut")) icon = "🔁";
            if (/Ticket créé|Ticket Created/.test(a.action)) icon = "📝";
            if (a.action.includes("Comment")) icon = "💬";
            return (
              <Box
                key={a.id}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  mb: 1,
                  p: 1,
                  borderRadius: 1,
                  bgcolor: "#f5f5f5",
                }}
              >
                <Avatar sx={{ width: 32, height: 32, mr: 1 }}>{icon}</Avatar>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" fontWeight={600}>
                    {a.performedBy}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    display="block"
                  >
                    {new Date(a.timestamp.seconds * 1000).toLocaleString()}
                  </Typography>
                  <Chip
                    label={a.action}
                    size="small"
                    sx={{
                      mt: 0.5,
                      bgcolor:
                        statusColors[a.action.split("→").pop().trim()] ||
                        "#ccc",
                      color: "#fff",
                    }}
                  />
                  {a.comment && (
                    <Typography variant="body2" sx={{ mt: 0.5 }}>
                      {a.comment}
                    </Typography>
                  )}
                </Box>
              </Box>
            );
          })
        ) : (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontStyle: "italic" }}
          >
            {translate("NoActivityYet")}
          </Typography>
        )}
      </Box>
      {/* Zone de commentaire */}
      <Box sx={{ mt: 2 }}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          label={translate("AddComment")}
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
        />
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 1 }}
          onClick={() => postComment(currentUser.displayName)} // <-- utilisation de currentUser
        >
          {translate("PostComment")}
        </Button>
      </Box>
    </Box>
  );
}
